<template>
    <div class="partner-rows-container" :class="classHandler">
        <template v-if="partners.length === 0">
            <PartnerRowPlaceholder v-for="p in 5" :key="p" />
        </template>

        <!--Double Ranking Start: FRON-2055 -->
        <template v-if="topPartners">
            <DoubleRankingTitle
                v-if="!isHeroBannerBeta"
                :content="doubleRankingTitle ?? $t('Best Games of')"
                :class="doubleRankingClass"
                :year="!doubleRankingTitle"
            >
            </DoubleRankingTitle>

            <component
                v-bind="partnerRowProps"
                :is="partnerRowType"
                v-for="(partner, index) in topPartners"
                :partner="partner"
                :showFlag="flagPositions.includes(index + 1)"
                :key="partner.partner_id + '_top3-partners'"
                :index="index"
                :category-name="categoryName"
                :showPartners="showPartners"
                :class="doubleRankingClass"
                :adBannerPosition="2000"
                :rankingBannerPosition="2000"
                :sidebarBillboardPosition="2000"
                :enhanceFirstPartnerDesktop="true"
                :enhanceFirstPartnerMobile="true"
            ></component>

            <DoubleRankingTitle
                :content="rankingTitle ?? $t('Top Games')"
                :class="doubleRankingClass"
                :year="!rankingTitle"
            >
            </DoubleRankingTitle>
        </template>
        <!--Double Ranking End -->
        <template v-for="(partner, index) in partners">
            <component
                v-bind="partnerRowProps"
                :is="partnerRowType"
                :index="index"
                :partner="partner"
                :showFlag="flagPositions.includes(index + 1)"
                :key="partner.partner_id"
                :category-name="categoryName"
                :observer="observer"
                :showPartners="showPartners"
                :adBannerPosition="
                    $globalConstants.components.AdBanner &&
                    $globalConstants.components.AdBanner.position - 1
                "
                :rankingBannerPosition="rankingBannerPosition - 1"
                :sidebarBillboardPosition="
                    $globalConstants.components.CategoryPage[
                        'sidebarBillboardPosition'
                    ]
                "
            />
        </template>
    </div>
</template>

<script>
import PartnerRowPlaceholder from '@organisms/PartnerRows/PartnerRowPlaceholder';
import { PARTNER_ROW_COMPONENTS } from '@organisms/PartnerRows/PartnerRow.constants';
import { HERO_COMPONENTS } from '@organisms/HeroBanners/HeroBanner.constants';
import DoubleRankingTitle from '@atoms/Text/DoubleRankingTitle.vue';
import { mediaQueriesMixin } from '@/mixins/mediaQueries';
import TipStripe from '@/design-system/2_molecules/TipStripe/TipStripe.vue';
export default {
    name: 'PartnerRowController',
    mixins: [mediaQueriesMixin],
    props: {
        observer: IntersectionObserver,
        partners: Array,
        showPartners: Array,
        partnerRowType: {
            type: String,
            default: PARTNER_ROW_COMPONENTS.PartnerRowAlpha,
        },
        flagPosition: {
            type: String,
            default: '1, 2',
        },
        doubleRankingClass: {
            type: String,
            default: 'double-ranking-items',
        },
        categoryName: {
            type: String,
            default: 'default',
        },
        doubleRankingTitle: {
            type: String,
            default: null,
        },
        rankingTitle: {
            type: String,
            default: null,
        },
        rankingBannerPosition: {
            type: Number,
            default: 0,
        },
    },
    components: {
        DoubleRankingTitle,
        PartnerRowAlpha: () =>
            import('@organisms/PartnerRows/PartnerRowAlpha/PartnerRowAlpha'),
        PartnerRowBeta: () =>
            import('@organisms/PartnerRows/PartnerRowBeta/PartnerRowBeta'),
        PartnerRowGamma: () =>
            import('@organisms/PartnerRows/PartnerRowGamma/PartnerRowGamma'),
        PartnerRowDelta: () =>
            import('@organisms/PartnerRows/PartnerRowDelta/PartnerRowDelta'),
        PartnerRowEpsilon: () =>
            import(
                '@organisms/PartnerRows/PartnerRowEpsilon/PartnerRowEpsilon'
            ),
        PartnerRowZeta: () =>
            import('@organisms/PartnerRows/PartnerRowZeta/PartnerRowZeta'),
        PartnerRowEta: () =>
            import('@organisms/PartnerRows/PartnerRowEta/PartnerRowEta'),
        PartnerRowPlaceholder,
        TipStripe,
    },
    data() {
        let classHandler = '';
        if (this.partnerRowType === 'PartnerRowDelta') {
            classHandler = 'delta-grid';
        }

        const flagPositions = this.flagPosition
            .replace(/ /g, '')
            .split(',')
            .map(Number);

        return {
            classHandler,
            flagPositions,
        };
    },
    computed: {
        isHeroBannerBeta() {
            try {
                const heroType =
                    this.$globalConstants.components['CategoryPage'][
                        'heroType'
                    ];

                return (
                    heroType === HERO_COMPONENTS.HeroBannerBeta &&
                    this.isDesktop()
                );
            } catch (e) {
                console.warn(e);
            }

            return false;
        },
        topPartners() {
            if (!this.$globalConstants.host['use_double_ranking']) return null;
            const rankingLength =
                this.$globalConstants.host['double_ranking_partner_amount'] ||
                3;
            return this.partners.length >= rankingLength
                ? this.partners.slice(0, rankingLength)
                : null;
        },
        partnerRowProps() {
            const type = PARTNER_ROW_COMPONENTS[this.partnerRowType];
            const props = this.$globalConstants.components[type];

            if (this.topPartners) {
                props['enhanceFirstPartnerDesktop'] = false;
                props['enhanceFirstPartnerMobile'] = false;
            }

            return props;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';

.partner-rows-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
    width: 100%;
    min-height: 700px;
    @include mq('tablet') {
        margin-top: 20px;
    }
}

.partner-rows-container.delta-grid {
    @include mq('tablet') {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        grid-gap: 20px;

        .partner-row-placeholder {
            grid-column: auto / span 6;
        }
    }
}
</style>
